var setDirectPlansClickHandler = function () {
  $(document).on('click', '.directPlans', function (event) {
    var directPlanLink = $(this);
    // Ensure href exists before removing
    var originalHref = directPlanLink.attr('href');

    if (!originalHref) { 
      return;
    }
    const disclaimerModalEl = document.getElementById('qhpDisclaimerModal');
    
    if (!disclaimerModalEl) {
      console.warn('Disclaimer modal element not found');
      return;
    }

    event.preventDefault();
    directPlanLink.data('originalHref', originalHref);
    directPlanLink.removeAttr('href');

    const disclaimerModal = new bootstrap.Modal(disclaimerModalEl);

    disclaimerModal.show();

    // Restore href and navigate when the continue button is clicked
    $('#continueButton')
      .off('click')
      .on('click', function () {
        if (directPlanLink.data('originalHref')) {
          directPlanLink.attr('href', directPlanLink.data('originalHref'));
          window.location.href = directPlanLink.attr('href');
        }

        disclaimerModal.hide();
      });

    // Ensure back button only restores href, no navigation
    $('#backButton')
      .off('click')
      .on('click', function () {
        if (directPlanLink.data('originalHref')) {
          directPlanLink.attr('href', directPlanLink.data('originalHref'));
        }
        disclaimerModal.hide();
      });
  });
};
